// extracted by mini-css-extract-plugin
export default {"container":"Test_container__S5LHw","row":"Test_row__r51cQ","card":"Test_card__7knOn","control":"Test_control__ZtZd5","left":"Test_left__uPG5+","right":"Test_right__YDgcj"};